import Vue from 'vue'

///////////////////////////////////////////////////////////////////////////////
// вспомогательные функции для работы с фильтром в additional-services
///////////////////////////////////////////////////////////////////////////////
const AdditionalServicesFilter = {
	all_ids: '',

	init() {
		const ids = [
			Vue.Constants.SERVICE_TYPE_VDS_IP4,
			Vue.Constants.SERVICE_TYPE_VDS_RAM,
			Vue.Constants.SERVICE_TYPE_VDS_SSD,
			Vue.Constants.SERVICE_TYPE_VDS_CPU,
			Vue.Constants.SERVICE_TYPE_VDS_TRAFF,
			Vue.Constants.SERVICE_TYPE_VDS_IP6,
			Vue.Constants.SERVICE_TYPE_VDS_LOAD,
			Vue.Constants.SERVICE_TYPE_RESERVE_IP,
			Vue.Constants.SERVICE_TYPE_GPU
		]

		ids.map(a => parseInt(String(a), 10)).sort()

		this.all_ids = ids.join(',')
	},

	is_all_ids(arr) {
		if (!arr || !arr.length) return false

		arr.map(a => parseInt(String(a), 10)).sort()

		return arr.join(',') === this.all_ids
	},

	filterValue(arr) {
		if (!arr || !arr.length) return null

		const ids = arr.map(a => a.id).filter(a => String(a) !== '-1')
		ids.map(a => parseInt(String(a), 10)).sort()
		return ids.join(',')
	},

	list(arr) {
		if (!arr || !arr.length) return null
		return arr.filter(a => (a && ('id' in a) && this.all_ids.indexOf(String(a.id)) > -1))
	}
}

///////////////////////////////////////////////////////////////////////////////
export default AdditionalServicesFilter
///////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// ./src/helper/additional-services-filters.js